import {FULFILLED} from 'redux-promise-middleware';
import {prop} from 'ramda';
import {
    createGAEvent,
    HTO,
    pushDataLayer,
    sendMobileAnalyticsEvent,
} from '@optimaxdev/analytics/mobile';

import {ActionType} from 'constants/flow/flowTypes';
import {PRODUCT, CART} from 'constants/actions';
import {call, select, takeEvery, cancel} from 'redux-saga/effects';
import {getSimpleProductInform} from 'selectors/analytics/analytics';
import {waitForFulfilled} from 'libs/utils/utils';
import {getActiveChildrenProductId} from 'selectors/product/product';
import {SimpleProductFrameMSType} from 'constants/flow/flowTypesProduct';
import {isHtoEnabled} from 'constants/flags/flags';

/**
 * Send HTO non-interaction analytics for pdp
 */
export function* sendPDPAnalytics() {
    yield call(waitForFulfilled, getActiveChildrenProductId, PRODUCT.SET_ACTIVE_PRODUCT_ID);
    const {eligibleForHto: isHTOEligible, sku, brand}: SimpleProductFrameMSType = yield select(
        getSimpleProductInform,
    );
    if (!sku) yield cancel();

    if (isHtoEnabled()) {
        yield call(
            sendMobileAnalyticsEvent,
            HTO.PDP_ELIGIBLE,
            {
                status: isHTOEligible ? 'Eligible' : 'Not Eligible',
                brand: brand ? prop('label', brand) : '',
                sku,
            },
            false,
        );
    }
}

/**
 * Click on the "Add To Home Try-On" button
 * @param {ActionType<{product_as_hto: number}>} action - Definition of clicking on the "Add To Home Try-On" button
 */
export function* sendPDPClickAnalytics(action: ActionType<{product_as_hto: number}>) {
    if (action.meta && action.meta.product_as_hto !== 1) return;

    const eligibleEvent = yield call(createGAEvent, HTO.PDP_CLICK);

    yield call(pushDataLayer, eligibleEvent);
}

/**
 * HTO analytics root saga.
 */
export default function* htoProductAnalyticsSaga() {
    yield takeEvery(PRODUCT.SET_PRODUCT, sendPDPAnalytics);
    yield takeEvery(`${CART.ADD_TO_CART}_${FULFILLED}`, sendPDPClickAnalytics);
}
